import {
  fetchDevCostTrends,
  fetchHeadcountTrends,
  fetchDevCostHeadcountTrendsByMilestone,
} from '@gp/services/projectDetail';
import { CONSTANT_KEYS, CONSTANT_TEXTS } from '@gp/constants/const';
import { getPeriodFlagName } from '@gp/enums/common';
import { FinancialsDataMode } from '../enums';

import type { IProjectDetailsFinanceTrendsParamsDTO } from '@gp/types/projectDetail';

const formatCommonTrendsByMilestone = (
  list: any[],
  periodAlias?: { historyName?: string; futureName?: string; },
): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { item: date, details } = item || {};
    const detailsNew = details?.map((detail: any) => {
      const { name } = detail || {};
      return { ...detail, name: getPeriodFlagName(name, periodAlias).toLowerCase() };
    });
    return { date, details: detailsNew || [] };
  });
};

const getHeadcountTableByTrendsData = (list: any[]): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  const result: Record<string, string>[] = [
    {
      type: CONSTANT_KEYS.ACTUAL,
      headcount: '',
    },
    {
      type: CONSTANT_KEYS.FORECAST,
      headcount: '',
    },
  ];
  const resultIndexs: Record<string, number> = {
    [CONSTANT_KEYS.ACTUAL]: 0,
    [CONSTANT_KEYS.FORECAST]: 1,
  };
  for (const item of list) {
    const { date, details } = item || {};
    if (Array.isArray(details) && details.length > 0) {
      for (const detail of details) {
        const { name, value } = detail || {};
        const resultIndex = resultIndexs[name] ?? -1;
        if (resultIndex !== -1) {
          result[resultIndex][date] = value;
        }
      }
    }
  }
  return result;
};

const formatHeadcountTrendsByMilestone = (resData: any): { list: any[]; table: any[]; } => {
  const { list } = resData || {};
  const listNew = formatCommonTrendsByMilestone(list, { futureName: CONSTANT_TEXTS.FORECAST });
  return {
    list: listNew || [],
    table: getHeadcountTableByTrendsData(listNew) || [],
  };
};

export const getDevCostTrends = async (
  params: IProjectDetailsFinanceTrendsParamsDTO & {
    mode: FinancialsDataMode;
  },
) => {
  const { mode, ...restParams } = params || {};
  const isByMilestone = mode === FinancialsDataMode.ByMilestone;

  if (isByMilestone) {
    const { project_id: projectId, studio_id: studioId } = restParams || {};
    const res = await fetchDevCostHeadcountTrendsByMilestone({
      type: '1',
      project_id: projectId,
      studio_id: studioId,
    });
    return { list: formatCommonTrendsByMilestone(res?.list) };
  }

  return fetchDevCostTrends(restParams);
};

export const getHeadcountTrends = async (
  params: IProjectDetailsFinanceTrendsParamsDTO & {
    mode: FinancialsDataMode;
  },
) => {
  const { mode, ...restParams } = params || {};
  const isByMilestone = mode === FinancialsDataMode.ByMilestone;

  if (isByMilestone) {
    const { project_id: projectId, studio_id: studioId } = restParams || {};
    const res = await fetchDevCostHeadcountTrendsByMilestone({
      type: '2',
      project_id: projectId,
      studio_id: studioId,
    });
    return formatHeadcountTrendsByMilestone(res);
  }

  return fetchHeadcountTrends(restParams);
};
